import { render, staticRenderFns } from "./Sem.vue?vue&type=template&id=27b4d048&scoped=true&"
import script from "./Sem.vue?vue&type=script&lang=js&"
export * from "./Sem.vue?vue&type=script&lang=js&"
import style0 from "./Sem.vue?vue&type=style&index=0&id=27b4d048&scoped=true&lang=css&"
import style1 from "./Sem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b4d048",
  null
  
)

export default component.exports